import ApiResourceManager from '../ApiResourceManager';

export default class PrintersManager extends ApiResourceManager {
  get = async () =>
    this.request({
      method: 'GET',
      url: '/printers',
    });
}
